<script setup lang="ts">
const props = defineProps<{
  group: LocationGroup
}>()
</script>

<template>
  <section>
    <header class="py-3 px-2">
      <h3 class="font-heading font-bold text-pretty text-lg text-primary-800 dark:text-primary-200">
        {{ props.group.label }}
      </h3>
    </header>
    <div class="divide-y divide-neutral-200 dark:divide-neutral-700">
      <LocationsListItem
        v-for="location in props.group.locations"
        :key="location.id"
        :location="location"
      />
    </div>
  </section>
</template>
